import gql from 'graphql-tag';

export const DEAL_LISTING_ACTIVITY_FRAGMENT = gql`
  fragment DealListingEventActivityFields on DealEventActivityViewModel {
    id
    notes
    allDay
    subject
    priority
    eventType
    activityStatus
    account {
      id
      name
    }

    participants {
      id
      fullName
      participationType
    }

    due {
      dueAt
      isOverdue
      secondsSinceDue
      secondsUntilDue
    }
  }
`;
